export function sortCategoriesByName<T extends { name: string }>(categories: T[]): T[] {
  return [...categories].sort((a, b) =>
    a.name.localeCompare(b.name, 'fr', { sensitivity: 'base', numeric: true })
  );
}
